import { HOMEPAGE_GPT_ID } from '@/lib/ads/ads-config/homepage/homepageAdSlots'

import { StyledGptLeaderBase } from './styled'

export const GptLeaderBottom = () => {
  return (
    <StyledGptLeaderBase
      id={HOMEPAGE_GPT_ID.LEADER_BOTTOM}
      data-testid={HOMEPAGE_GPT_ID.LEADER_BOTTOM}
    />
  )
}
